import { useState } from 'react';
import { useLabelTemplates } from '../../../hooks/queries/useReunification';

export function useLabelTemplatesCrud(templateId: string) {
  const { data: labels, isLoading } = useLabelTemplates(templateId);
  const [drawerOpen, setDrawerOpen] = useState(false);

  return { labels, isLoading, drawerOpen, setDrawerOpen };
}
